import { useHistory } from "#src/components/Router.tsx";
import { ConfirmModal } from "#src/components/modals/ConfirmModal.tsx";
import { useSession } from "#src/stores/Session.tsx";
import { useStore } from "#src/stores/Store.tsx";
import { modals } from "#src/utils/modals.ts";
import tw from "#src/utils/tw.ts";
import { useEffect, useState } from "react";
import { BorderButton } from "../buttons/BorderButton";

export default function HeaderCartButton(_props) {
  const store = useStore();
  const session = useSession();
  const [animate, setAnimate] = useState(true);
  const history = useHistory();

  const totalRegistrations =
    session.groupRegistrations.length +
    session.privateSeries.length +
    session.memberships.length;

  useEffect(() => {
    setAnimate(false);

    const timeout = setTimeout(() => {
      setAnimate(true);
    }, 32);

    return () => clearTimeout(timeout);
  }, [session.groupRegistrations, session.privateSeries, session.memberships]);

  function clearCart() {
    modals.show(ConfirmModal, {
      handleOk: async () => {
        if (store.user?.isAdminOrAbove) {
          session.clearSession();
          // history.push("/admin");
        } else {
          session.clearUserSession();
        }
      },
      title: "Clear Cart?",
      body: <p>Would you like to clear your cart selections?</p>,
      buttonText: "Yes, clear it",
      cancelText: "Nevermind",
    });
  }

  function checkout() {
    if (store.isAdminArea) {
      history.push(`/admin/checkout${location.search}`);
    } else {
      history.push("/checkout");
    }
  }

  if (!store.isAdminArea) {
    return (
      <BorderButton
        onClick={checkout}
        small
        type="submit"
        className={tw("leading-none", animate && "animate-cartBounce")}
        style={{
          animationDelay: ".25s",
        }}
      >
        Cart <i aria-hidden className="far fa-cart-shopping mr-1 ml-0.5" />{" "}
        <strong>{totalRegistrations}</strong>
      </BorderButton>
    );
  }

  return (
    <>
      <div
        id="cart-button"
        style={{
          animationDelay: ".25s",
        }}
        className={tw(
          animate && "animate-cartBounce",
          "inline-block",
          "align-top",
          "border-b-3",
          "border",
          "rounded-full",
          "cursor-pointer",
          "overflow-hidden",
          "h-9",
          "truncate",
          "border-borderGray",
          "bg-lightGray"
        )}
      >
        <div className="flex h-full items-stretch">
          <div className="border-borderGray flex flex-1 items-center border-r">
            <button
              onClick={checkout}
              className="active:bg-borderGray h-full cursor-pointer pr-2.5 pl-4"
            >
              <i aria-hidden className="far fa-cart-shopping mr-1" />{" "}
              <strong>{totalRegistrations}</strong>
            </button>
          </div>
          <button
            className="active:bg-borderGray cursor-pointer pr-4 pl-3"
            onClick={clearCart}
          >
            <i aria-hidden className="far fa-trash-can" />
          </button>
        </div>
      </div>
    </>
  );
}
